import type { BimWorkOrderOtherPriceData, WorkOrderStatusEnum } from 'gql/graphql';
import { useAccess } from 'hooks/useAccess';
import type { ContextMenuItemDefault } from 'uikit';

import { useMemo } from 'react';

import { getBimWorkOrderOtherTableRowMenuItemsAvailability } from '../utils/getBimWorkOrderOtherTableRowMenuItemsAvailability';

interface IUseBimWorkOrderOtherTableRowMenu {
    openSingleDeleteModalHandler: () => void;
    handleOpenDistributionModal: () => void;
    handleOpenEditModal: () => void;
    handleOpenViewModal: () => void;
    statusWorkOrder: WorkOrderStatusEnum;
    dataRow?: BimWorkOrderOtherPriceData;
    isFrameContract: boolean;
}

export const useBimWorkOrderOtherTableRowMenu = (props: IUseBimWorkOrderOtherTableRowMenu) => {
    const {
        openSingleDeleteModalHandler,
        handleOpenEditModal,
        handleOpenDistributionModal,
        handleOpenViewModal,
        dataRow,
        statusWorkOrder,
        isFrameContract,
    } = props;

    const { orderBim: orderBimRules } = useAccess({
        workOrderStatus: statusWorkOrder,
    });

    const availabilityMap = useMemo(
        () =>
            getBimWorkOrderOtherTableRowMenuItemsAvailability({
                statusWorkOrder,
                isFrameContract,
                dataRow,
            }),
        [dataRow, isFrameContract, statusWorkOrder],
    );

    const items: ContextMenuItemDefault[] = useMemo(
        () => [
            ...(availabilityMap.ChangeDistribution
                ? [
                      {
                          label: 'Изменить распределение',
                          action: handleOpenDistributionModal,
                          disabled: !orderBimRules.canEditOtherDistribution,
                      },
                  ]
                : []),
            ...(availabilityMap.Edit
                ? [
                      {
                          label: 'Редактировать',
                          action: handleOpenEditModal,
                      },
                  ]
                : []),
            ...(availabilityMap.View
                ? [
                      {
                          label: 'Просмотреть',
                          action: handleOpenViewModal,
                      },
                  ]
                : []),
            ...(availabilityMap.Delete
                ? [
                      {
                          label: 'Удалить',
                          action: openSingleDeleteModalHandler,
                          disabled: !orderBimRules.canEdit,
                      },
                  ]
                : []),
        ],
        [
            availabilityMap.ChangeDistribution,
            availabilityMap.Edit,
            availabilityMap.View,
            availabilityMap.Delete,
            handleOpenDistributionModal,
            orderBimRules.canEditOtherDistribution,
            orderBimRules.canEdit,
            handleOpenEditModal,
            handleOpenViewModal,
            openSingleDeleteModalHandler,
        ],
    );

    return {
        items,
    };
};
